import React from 'react';
import { useLazyLoadQuery } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';

import { ListChatActivityAssignees, ListChatActivityAssigneesProps } from 'deprecated/fragments';

import {
  QueryListChatActivityAssigneesQuery,
  QueryListChatActivityAssigneesQueryVariables,
} from './__generated__/QueryListChatActivityAssigneesQuery.graphql';

export interface QueryListChatActivityAssigneesProps
  extends Omit<
    ListChatActivityAssigneesProps,
    'fragmentRef' | 'includeMe' | 'includeAvatar' | 'includeEmail' | 'includeChatActivityCount'
  > {
  variables?: QueryListChatActivityAssigneesQueryVariables;
}

const QueryListChatActivityAssignees: React.FC<QueryListChatActivityAssigneesProps> = ({ variables = {}, ...rest }) => {
  const data = useLazyLoadQuery<QueryListChatActivityAssigneesQuery>(
    graphql`
      query QueryListChatActivityAssigneesQuery(
        $regex: String = ""
        $includeAvatar: Boolean = false
        $includeEmail: Boolean = false
        $includeChatActivityCount: Boolean = false
        $filterChatActivityCount: FilterChatActivityInput = null
      ) {
        ...ListChatActivityAssignees_Query
          @arguments(
            regex: $regex
            includeAvatar: $includeAvatar
            includeEmail: $includeEmail
            includeChatActivityCount: $includeChatActivityCount
            filterChatActivityCount: $filterChatActivityCount
          )
      }
    `,
    variables,
    { fetchPolicy: 'network-only' },
  );

  return (
    <ListChatActivityAssignees
      fragmentRef={data}
      includeMe={!variables.regex || variables.regex === '(?i)me'}
      includeAvatar={variables.includeAvatar || false}
      includeEmail={variables.includeEmail || false}
      includeChatActivityCount={variables.includeChatActivityCount || false}
      {...rest}
    />
  );
};

export default QueryListChatActivityAssignees;
